
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
// Authentication layout components
import React, {useEffect, useState} from "react";
import * as yup from "yup";
import YupPassword from 'yup-password';
YupPassword(yup);
import Grid from "@mui/material/Grid";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import quickbooksBigLogo from "assets/images/logos/QuickBooks/quickbooks-brand-preferred-logo-50-50-black-external.png"
import quickbooksLogo from "assets/images/logos/QuickBooks/C2QB_green_btn_short_default.svg";
import quickbooksLogoHover from "assets/images/logos/QuickBooks/C2QB_green_btn_short_hover.svg"
import {
    get_quickbooks_flag,
    getQBTest,
    onErrorAlert,
    onSuccessAlert,
    quickbook_generate_invoice
} from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import {Quickbook_Generate_Invoice} from "../../../config";
import LocalStorage from "../../../utils/LocalStorage";
import {useTranslation} from "react-i18next";
function ConnectionPage() {
    const [linkStyle,setLinkStyle] = useState({color:"#3F50B5",display:"flex" })
    const [logo,setLogo] = useState(quickbooksLogo)
    const [isLoading, setIsLoading] = useState(true)
    const [authenticated, setAuthenticated] = useState(null);
    const dispatch = useDispatch()
    const {t} = useTranslation();
    useEffect(()=>{
        getAuthenticated()
    },[])

    const getAuthenticated = () => {
        const axiosPost = async () => {
            if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                await dispatch(get_quickbooks_flag(getQuickBooksFlagSuccess))
            }
        }
        axiosPost().then(()=>{
            setIsLoading(false)
        })
    }

    const getQuickBooksFlagSuccess = (data) => {
        setAuthenticated(!data)
    }


    const openLoginWindow = async () => {
        dispatch(getQBTest(onSuccessAlert,onErrorAlert,getAuthenticated))
    }
    const openLoginWindow1 = () => {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceConnect)) return null;
        const url = `${Quickbook_Generate_Invoice}`
        // 计算窗口的左上角位置
        const width = 400;
        const height = 600;
        const left = (screen.width / 2)-200;
        const top = (screen.height / 2)-400;

        // 打开一个小窗口，设置尺寸和其他选项
        const loginWindow = window.open(
            process.env.REACT_APP_BASE_URL+url, // 这里是你想要打开的 URL
            'LoginWindow',
            `width=${width},height=${height},left=${left},top=${top}`
        );

        window.addEventListener("message", function(event) {
            // 检查消息来源是否为子窗口的URL
            // if (event.origin === "子窗口的URL") {
                if (event.data === "close") {
                    // console.log("收到关闭消息");
                    // 关闭子窗口或执行其他操作
                    dispatch(onSuccessAlert('Connect QuickBooks Successfully.'))
                    getAuthenticated()
                    // loginWindow.close();
                }
            // }
        });


    };


    return (
        <React.Fragment>
            <MDBox  style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                alignItems: 'normal',
                marginBottom: '20px',
                flexWrap: 'wrap',
            }}>
                <MDTypography variant="h6" fontWeight="medium">
                    {t("AccountPage.Connections")}
                </MDTypography>
                <MDTypography fontSize="14px">
                    {t("AccountPage.Manage your linked accounts and services")}
                </MDTypography>
            </MDBox>
            {
                checkPermission(PERMISSION_DICT.BillingCollectionAdd) &&
                <MDBox style={{ marginTop:"40px" }}>
                    <Grid container>
                        <Grid item xs={1.5} sx={{minWidth:"100px",display:"flex",alignItems:'center'}}>
                            <MDBox sx={{display:"flex"}}>
                                <MDBox component="img" src={quickbooksBigLogo} alt="QuickBooks" width={"80%"}/>
                            </MDBox>
                            {/*<MDTypography style={{fontWeight:"bold",display: 'flex', fontSize:"14px", marginBottom:"20px",marginTop:"20px",paddingLeft:"20px" }}>*/}
                            {/*    QuickBooks*/}
                            {/*</MDTypography>*/}
                        </Grid>
                        <Grid item xs={10.5} >
                            <div style={{maxWidth: "700px",display: 'flex', flexDirection: "column", fontSize:"14px", marginBottom:"20px",marginTop:"20px" }}>
                                {
                                    !isLoading &&
                                    (
                                        authenticated === true ?
                                            <MDTypography color={'success'} style={{fontSize:"14px"}}>
                                                {t("AccountPage.You have successfully connected to QuickBooks.")}
                                            </MDTypography>
                                            :
                                            <div style={linkStyle}
                                                 onMouseOver={() => {
                                                     setLogo(quickbooksLogoHover);
                                                     setLinkStyle(
                                                         {color:"#3F50B5",display:"flex" ,cursor: "pointer"}
                                                     )
                                                 }}
                                                 onMouseLeave={() => {
                                                     setLogo(quickbooksLogo);
                                                 }}
                                                 onClick={openLoginWindow}
                                            > <MDBox component="img" src={logo} alt="QuickBooks"/>
                                                {/*<div style={linkStyle}*/}
                                                {/*     onMouseOver={() => {*/}
                                                {/*         setLinkStyle({*/}
                                                {/*             color: "#3F50B5",*/}
                                                {/*             cursor: "pointer",*/}
                                                {/*             textDecorationLine: "underline"*/}
                                                {/*         })*/}
                                                {/*     }}*/}
                                                {/*     onMouseLeave={() => {*/}
                                                {/*         setLinkStyle({color: "#3F50B5"})*/}
                                                {/*     }}*/}
                                                {/*     onClick={() => {*/}
                                                {/*         // setOpenPasswordChange(true)*/}
                                                {/*     }}*/}
                                                {/*>*/}
                                                {/*    Connect*/}
                                                {/*</div>*/}
                                                {/*<div style={{fontSize:"18px", marginLeft:"10px",display:"flex",alignItems:'center'}}>*/}
                                                {/*    <Icon>add_link</Icon>*/}
                                                {/*</div>*/}

                                            </div>
                                    )
                                }


                                <div>
                                    {t("AccountPage.Connect your QuickBooks account to quickly generate invoices with ease.")}
                                </div>
                            </div>
                        </Grid>
                        {/*<Grid item xs={1.5} sx={{minWidth:"100px"}}>*/}
                        {/*    <MDBox style={{fontWeight: "bold", display: 'flex', fontSize: "14px",flexWrap: "wrap", marginBottom:"20px",marginTop:"20px"  ,paddingLeft:"20px"}}>*/}
                        {/*        <MDTypography style={{fontWeight:"bold",fontSize: "14px"}}>*/}
                        {/*            Two-Factor*/}
                        {/*        </MDTypography>*/}
                        {/*        <MDTypography style={{fontWeight:"bold",fontSize: "14px"}}>*/}
                        {/*            Authentication*/}
                        {/*        </MDTypography>*/}
                        {/*    </MDBox>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={10.5}>*/}
                        {/*    <MDBox style={{display: 'flex',flexDirection: "column", fontSize:"14px" , marginBottom:"20px",marginTop:"20px" }}>*/}
                        {/*        <MDBox>*/}
                        {/*            <Tooltip title={'COMING SOON'}>*/}
                        {/*                <MDButton variant="gradient" color="info" size="small" disabled*/}
                        {/*                >coming soon... </MDButton>*/}
                        {/*            </Tooltip>*/}
                        {/*        </MDBox>*/}
                        {/*        <MDTypography style={{maxWidth: "700px", marginTop: "10px", fontSize: "14px"}}>*/}
                        {/*            Secure your Darwynn account with two-factor authentication (2FA) using both your*/}
                        {/*            password and a mobile phone code for login.*/}
                        {/*        </MDTypography>*/}
                        {/*    </MDBox>*/}
                        {/*</Grid>*/}
                    </Grid>
                </MDBox>
            }
        </React.Fragment>
    );
}

export default ConnectionPage;
